import wx from "weixin-js-sdk"; // 引入wx
import request from "./request";
import { IWXResponse, IWXConfig } from "@/api/types";
import { recordShare } from "@/api/dataCollect";

/** *
 * 微信分享(废弃)
 * @param shareTitle 分享标题
 * @param shareDesc 分享详情，摘要，简介
 * @param shareLink 分享的链接 会到redirect.html 中去重定向到分享页面
 * @param shareImgUrl 分享图片地址
 */
export function wxChatShare(
  shareTitle: string,
  shareDesc: string,
  shareLink: string,
  shareImgUrl: string
) {
  const _url = `//actweb.cqliving.com/weixin/getsc.html?a=6&url=${encodeURIComponent(
    window.location.href.split("#")[0]
  )}`;
  request.post<any, IWXResponse>(_url).then(res => {
    const { code, data } = res;
    if (code >= 0) {
      const result: IWXConfig = JSON.parse(data);
      // 若要打印提示，则设置为true
      result.debug = false;
      wx.config(result);
      wx.ready(() => {
        // 分享到朋友圈
        wx.onMenuShareTimeline({
          title: shareTitle,
          link: shareLink,
          imgUrl: shareImgUrl,
          desc: shareDesc,
          success: function() {
            // 分享埋点
            recordShare({ platform: "微信朋友圈", failReason: "" });
          },
          cancel: function() {
            // 用户取消分享后执行的回调函数
            recordShare({ platform: "微信朋友圈", failReason: "用户取消分享" });
          }
        });

        // 分享给朋友
        wx.onMenuShareAppMessage({
          title: shareTitle,
          desc: shareDesc,
          link: shareLink,
          imgUrl: shareImgUrl,
          success: function() {
            // 分享埋点
            recordShare({ platform: "微信好友", failReason: "" });
          },
          cancel: function() {
            // 用户取消分享后执行的回调函数
            recordShare({ platform: "微信好友", failReason: "用户取消分享" });
          }
        });

        // 分享到QQ
        wx.onMenuShareQQ({
          title: shareTitle,
          desc: shareDesc,
          link: shareLink,
          imgUrl: shareImgUrl,
          success: function() {
            // 分享埋点
            recordShare({ platform: "QQ好友", failReason: "" });
          },
          cancel: function() {
            // 用户取消分享后执行的回调函数
            recordShare({ platform: "QQ好友", failReason: "用户取消分享" });
          }
        });
      });
    }
  });
}

/** *
 * 微信内h5 跳转到app
 */
export function wxChatJumpApp(
  a: string,
  shareData: {
    shareTitle: string;
    shareDesc: string;
    shareLink: string;
    shareImgUrl: string;
  }
) {
  a ? "" : (a = "99");
  const url =
    `/weChat/jsapiSignature?weChatId=${a}&url=` +
    encodeURIComponent(window.location.href.split("#")[0]);
  request
    .get<any, IWXResponse>(url, {
      baseURL: "https://gatewayapi.cqliving.com/cqliving-boot-sso"
    })
    .then(res => {
      const { code, data } = res;
      if (code >= 0) {
        const result = data;
        console.log(result);
        // 若要打印提示，则设置为true
        result.debug = false;
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
          appId: result.wxAppId, // 必填，公众号的唯一标识
          timestamp: result.timestamp, // 必填，生成签名的时间戳
          nonceStr: result.nonceStr, // 必填，生成签名的随机串
          signature: result.signature, // 必填，签名
          jsApiList: [
            "onMenuShareTimeline",
            "onMenuShareAppMessage",
            "onMenuShareQQ",
            "onMenuShareWeibo",
            "wx-open-launch-app"
          ],
          openTagList: ["wx-open-launch-app"] // 跳转app
        });
        wx.ready(() => {
          console.log("注入成功app");
          // 分享到朋友圈
          wx.onMenuShareTimeline({
            title: shareData.shareTitle,
            link: shareData.shareLink,
            imgUrl: shareData.shareImgUrl,
            desc: shareData.shareDesc,
            success: function() {
              // 分享埋点
              recordShare({ platform: "微信朋友圈", failReason: "" });
            },
            cancel: function() {
              // 用户取消分享后执行的回调函数
              recordShare({
                platform: "微信朋友圈",
                failReason: "用户取消分享"
              });
            }
          });

          // 分享给朋友
          wx.onMenuShareAppMessage({
            title: shareData.shareTitle,
            desc: shareData.shareDesc,
            link: shareData.shareLink,
            imgUrl: shareData.shareImgUrl,
            success: function() {
              // 分享埋点
              recordShare({ platform: "微信好友", failReason: "" });
            },
            cancel: function() {
              // 用户取消分享后执行的回调函数
              recordShare({ platform: "微信好友", failReason: "用户取消分享" });
            }
          });

          // 分享到QQ
          wx.onMenuShareQQ({
            title: shareData.shareTitle,
            desc: shareData.shareDesc,
            link: shareData.shareLink,
            imgUrl: shareData.shareImgUrl,
            success: function() {
              // 分享埋点
              recordShare({ platform: "QQ好友", failReason: "" });
            },
            cancel: function() {
              // 用户取消分享后执行的回调函数
              recordShare({ platform: "QQ好友", failReason: "用户取消分享" });
            }
          });
        });
        wx.error((e: any) => {
          console.log("-----wx.error");
          console.log(e.detail);
        });
      }
    });
}

/** *
 * 跳转到小程序
 */
export function wxChatJumpMini() {
  const url =
    "/getsc.html?a=70&url=" +
    encodeURIComponent(window.location.href.split("#")[0]);
  request
    .get<any, IWXResponse>(url, { baseURL: "//actweb.cqliving.com/weixin" })
    .then(res => {
      const { code, data } = res;
      if (code >= 0) {
        const result = JSON.parse(data);
        console.log(result);
        // 若要打印提示，则设置为true
        result.debug = false;
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
          appId: result.appId, // 必填，公众号的唯一标识
          timestamp: result.timestamp, // 必填，生成签名的时间戳
          nonceStr: result.nonceStr, // 必填，生成签名的随机串
          signature: result.signature, // 必填，签名
          jsApiList: ["wx-open-launch-weapp"],
          openTagList: ["wx-open-launch-weapp"] // 跳转小程序时必填
        });
        wx.ready(() => {
          console.log("注入成功wx");
        });
        wx.error((e: any) => {
          console.log(e.detail);
        });
      }
    });
}
